import { I18n } from 'i18n-js';
import { useCallback, useMemo } from 'react';
import translations from '../../assets/i18/localise.json';
import { useAppSelector } from './store-hook';

const useTranslation = (props?: { defaultPath: string } | undefined) => {
  const locale = useAppSelector((selector) => selector.userPrefs.uiLanguage) ?? process.env.REACT_APP_DEFAULT_LANG ?? 'en';
  const i18n = useMemo(
    () =>
      new I18n(translations, { locale, enableFallback: true }),
    [locale],
  );
  const defaultPath = props?.defaultPath;
  return useCallback(
    (key: string, formatting?: any) => {
      let prefix = 'pm_mysteryshopping';

      if (defaultPath) {
        prefix = `${prefix}.${defaultPath}`;
      }

      if (!formatting) {
        return i18n.t(`${prefix}.${key}`, { defaultValue: key });
      } else {
        return i18n.t(`${prefix}.${key}`, { defaultValue: key, ...formatting });
      }
    },
    [i18n, defaultPath]
  );
};

export default useTranslation;
